(function () {
  'use strict';

  // Desktop drag-to-scroll for the collection link-card carousel.
  // Touch devices scroll natively; this covers mouse users.
  document.querySelectorAll('[data-drag-scroll]').forEach(function (track) {
    var isDown = false;
    var moved = false;
    var startX = 0;
    var startScroll = 0;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      isDown = true;
      moved = false;
      startX = e.clientX;
      startScroll = track.scrollLeft;
    });

    track.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      var delta = e.clientX - startX;
      if (Math.abs(delta) > 5 && !moved) {
        moved = true;
        track.classList.add('is-dragging');
      }
      if (moved) track.scrollLeft = startScroll - delta;
    });

    function release() {
      if (!isDown) return;
      isDown = false;
      setTimeout(function () {
        track.classList.remove('is-dragging');
      }, 0);
    }

    track.addEventListener('pointerup', release);
    track.addEventListener('pointerleave', release);

    // Suppress the click that follows a drag so cards don't navigate.
    track.addEventListener('click', function (e) {
      if (moved) {
        e.preventDefault();
        moved = false;
      }
    }, true);
  });
})();

(function () {
  'use strict';
  /* Chip clicks: one event per tap so we can see whether the category row is used at all. */
  document.querySelectorAll('[data-chip-row]').forEach(function (row) {
    row.addEventListener('click', function (e) {
      var chip = e.target.closest('.collection-link-card');
      if (!chip || row.classList.contains('is-dragging')) return;
      var detail = { event: 'collection_chip_click', chip_label: chip.getAttribute('data-chip-label') || '', chip_index: chip.getAttribute('data-chip-index') || '', chip_url: chip.getAttribute('href') || '', collection: row.getAttribute('data-chip-row') || '' };
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(detail);
      if (typeof window.gtag === 'function') { try { window.gtag('event', 'collection_chip_click', { chip_label: detail.chip_label, chip_url: detail.chip_url, collection: detail.collection }); } catch (err) {} }
    });
  });
})();
